module.exports = __webpack_public_path__ + "img/vintage@2x.050ad6c.jpg";